import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type UserStatusState = {
  plan: string;
  error?: unknown;
};

const initialState: UserStatusState = {
  plan: "default",
};

export const userStatusSlice = createSlice({
  name: "userStatus",
  initialState,
  reducers: {
    updateUserStatusPlan: (state, action: PayloadAction<string>) => {
      state.plan = action.payload;
    },
    handleUserStatusError: (state, action: PayloadAction<unknown>) => {
      state.error = action.payload;
    },
  },
});

export const { updateUserStatusPlan, handleUserStatusError } = userStatusSlice.actions;
export default userStatusSlice.reducer;
